import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { DisabledTimeFn, NzDatePickerComponent } from 'ng-zorro-antd/date-picker';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { CookieService } from 'ngx-cookie-service';
import { worklogM } from 'src/app/Models/BasicForms/worklogM';
import { ApiService } from 'src/app/Service/api.service';
import { differenceInCalendarDays, setHours } from 'date-fns';
import { NgForm } from '@angular/forms';
import { taskSubtaskMaster } from 'src/app/Models/BasicForms/taskSubtaskMaster';

@Component({
  selector: 'app-view-pms-work-log',
  templateUrl: './view-pms-work-log.component.html',
  styleUrls: ['./view-pms-work-log.component.css'],
  providers: [DatePipe]
})
export class ViewPmsWorkLogComponent implements OnInit {
  worklogData: any = [];
  allWorklogData: any = [];
  isWorklogSpinning: boolean = false;
  isWorklogLoadMoreButtonSpinning: boolean = false;
  isWorklogLoadMoreButtonHide: boolean = false;
  totalhours: any = 0;
  totalminutes: any = 0
  totalseconds: any = 0
  worklogAddMorePage = 5;
  worklogNextPage = 1;
  loggedUserID: any;
  projectList: any[] = [];
  isListLoading: boolean = false;
  PARENT_TASK_ID: any;
  SUBTASK_PARENT_TASK_ID: any;
  SUBTASK_FEATURE_ID: any;
  SUBTASK_MODULE_ID: any;
  PROJECT_ID: any;
  WORKED_DATETIMEs: Date = new Date();
  USER_NAME = ''
  constructor(private _apiService: ApiService, private notificationService: NzNotificationService, private datePipe: DatePipe, public cookie: CookieService, private renderer: Renderer2) { }


  ngOnInit(): void {
    this.loggedUserID = this._apiService.userId;
    this.getWorklogIDWise(this.worklogNextPage, this.worklogAddMorePage);
    this._apiService.getAllMappedProjects(0, 0, 'START_DATE', 'desc', ' and IS_ACTIVE=1 and USER_ID=' + this.loggedUserID).subscribe(projectData => {
      if (projectData['code'] == 200) {
        this.isListLoading = false;
        this.projectList = projectData['data'];
      } else {
        this.isListLoading = false;
      }
    }, err => {
      this.isListLoading = false;

    });
    this.USER_NAME = this._apiService.createBadge(this.cookie.get("userName"));
  }
  disableFuterDates = (current: Date): boolean => {
    const today = new Date();
    return current > today;
  };
  loadMoreWorklogIDWise() {
    this.worklogAddMorePage = this.worklogAddMorePage + 5;
    this.getWorklogIDWise(this.worklogNextPage, this.worklogAddMorePage);
  }
  worklogcount: any = 0;
  spinMain: boolean = false;
  getWorklogIDWise(pageIndex: number = 1, pageSize: number = 10) {
    this.isWorklogLoadMoreButtonHide = false;

    if (pageSize == 10) {
      this.isWorklogSpinning = true;
      this.worklogAddMorePage = 10;

    } else {
      this.isWorklogLoadMoreButtonSpinning = true;
    }
    var datetime = '';
    if (this.WORKED_DATETIMEs != null && this.WORKED_DATETIMEs != undefined) {
      datetime = " and date(WORKED_DATETIME)='" + this.datePipe.transform(this.WORKED_DATETIMEs, 'yyyy-MM-dd') + "'";
    } else {
      datetime = '';
    }

    let filterStr = " and IS_ACTIVE=1 and USER_ID=" + this.loggedUserID + datetime;
    this.spinMain = true;
    this._apiService.getAllWorklogs(pageIndex, pageSize, 'WORKED_DATETIME', 'desc', filterStr).subscribe(data => {
      if (data['code'] == 200) {
        this.isWorklogSpinning = false;
        this.spinMain = false;
        this.isWorklogLoadMoreButtonSpinning = false;
        this.worklogData = data['data'];
        this.worklogcount = data['count'];
        this.totalhours = 0;
        this.totalminutes = 0;
        this.totalseconds = 0;

        if (data['count'] > 0) {
          this.totalhours = Math.floor(this.worklogData.reduce((sum, item) => sum + Number(item.SPENT_HOURS), 0));
          this.totalminutes = Math.floor(this.worklogData.reduce((sum, item) => sum + Number(item.SPENT_MINUTES), 0));
          this.totalseconds = Math.floor(this.worklogData.reduce((sum, item) => sum + Number(item.SPENT_SECONDS), 0));

          // Handle conversion of seconds and minutes
          if (this.totalseconds >= 60) {
            this.totalminutes += Math.floor(this.totalseconds / 60);
            this.totalseconds = this.totalseconds % 60;
          }
          if (this.totalminutes >= 60) {
            this.totalhours += Math.floor(this.totalminutes / 60);
            this.totalminutes = this.totalminutes % 60;
          }
        } else {
          this.totalhours = 0;
          this.totalminutes = 0;
          this.totalseconds = 0;
        }
        if (data['data'].length == data['count']) {
          this.isWorklogLoadMoreButtonHide = true;
        }
      } else {
        this.spinMain = false;
        this.worklogData = [];
        this.worklogcount = 0;
        this.totalhours = 0;
        this.totalminutes = 0;
        this.totalseconds = 0;
        this.isWorklogSpinning = false;
        this.isWorklogLoadMoreButtonSpinning = false;
      }
    }, err => {
      this.spinMain = false;
      this.isWorklogSpinning = false;
      this.isWorklogLoadMoreButtonSpinning = false;
      if (err['ok'] == false)
        this.notificationService.error("Server Not Found", "");
    });
  }
  handleConfirmForWorklog(worklog: worklogM) {
    if (worklog.ID) {
      this._apiService.deleteWorklog(worklog.ID).subscribe(successCode => {
        if (successCode['code'] == "200") {
          this.notificationService.success("Work Log Deleted Successfully", "");
          this.getWorklogIDWise();

        } else {
          this.notificationService.error("Failed to Delete Work Log", "");
        }

      }, err => {
        if (err["ok"] == false) {
          this.notificationService.error("Server Not Found", "");
        }
      });
    }
  }
  datee: any;
  disabledDateprevious = (current: Date): boolean => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    this.datee = current;
    return current < yesterday;
  };
  handleCancelForWorklog(): void { }
  worklogDrawerVisible = false;
  worklogDrawerTitle = "";
  worklogDrawerData: worklogM = new worklogM();
  typeForWorklogDrawer: number;
  typeIDForWorklogDrawer: number;

  estimatedHH: any;
  estimatedMM: any;
  estimatedSS: any;
  logtext: string = "";
  type: any;
  typeID: any;
  today = new Date();
  timeDefaultValue = setHours(new Date(), 0);
  showtrue: boolean = false;
  disabledStartDate = (current: Date): boolean =>
    differenceInCalendarDays(current, this.today) > 0;
  @ViewChild('startDatePicker', { read: ElementRef }) startDatePicker: ElementRef
  @ViewChild('startDatePicker1', { read: ElementRef }) startDatePicker1: ElementRef

  editWorklog(data: worklogM) {
    setTimeout(() => {
      this.startDatePicker1.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      this.renderer.selectRootElement(this.startDatePicker.nativeElement, true).focus();
    }, 0);
    this.worklogDrawerTitle = "Work Log Details";
    this.worklogDrawerData = Object.assign({}, data);
    this.worklogDrawerVisible = true;
    this.type = data.TYPE;
    this.showtrue = true;
    this.logtext = 'EDIT - Worklog form KEYWORD [E - Worklog] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {
      }
      else {
      }
    });
  }

  isWorklogVisible = false;
  worklogModalName: string;
  worklogDescription: string;
  worklogDateTime: string;
  worklogStartDateTime: string;
  worklogEndDateTime: string;
  worklogSpentTime: string;
  worklogAuthor: string;
  isWorklogAuthorUserLoading = false;
  showWorklogModal(worklog): void {
    this.isWorklogVisible = true;
    this.worklogModalName = "Work Log Details";

    this.worklogDescription = worklog.WORK_DESCRIPTION;
    this.worklogSpentTime = worklog.SPENT_HOURS + "h " + worklog.SPENT_MINUTES + "m " + worklog.SPENT_SECONDS + "s ";
    this.worklogDateTime = worklog.WORKED_DATETIME;
    this.worklogStartDateTime = worklog.START_DATETIME;
    this.worklogEndDateTime = worklog.END_DATETIME;

    this.isWorklogAuthorUserLoading = true;
    var worklogAuthorID = worklog.USER_ID;
    this._apiService.getAllUsers(0, 0, 'ID', 'desc', ' and ID=' + worklogAuthorID).subscribe(userData => {
      this.isWorklogAuthorUserLoading = false;
      this.worklogAuthor = userData['data'][0]['NAME'];
    }, err => {
      this.isWorklogAuthorUserLoading = false;
    });
  }

  handleWorklogCancel(): void {
    this.isWorklogVisible = false;
  }

  generateBadge(nameForBadge: string) {
    return this._apiService.createBadge(nameForBadge);
  }

  radioButtonChange(data: any) {
    if (data != null && data != undefined && data != '') {
      this.moduleList = [];
      this.SUBTASK_MODULE_ID = null;
      this.subtaskFeatureList = [];
      this.SUBTASK_FEATURE_ID = null;
      this.parentTaskList = [];
      this.PARENT_TASK_ID = null;
      this.parentsubTaskList = [];
      this.SUBTASK_PARENT_TASK_ID = null;
      this.loadAllModules();
    } else {
      this.moduleList = [];
      this.SUBTASK_MODULE_ID = null;
      this.subtaskFeatureList = [];
      this.SUBTASK_FEATURE_ID = null;
      this.parentTaskList = [];
      this.PARENT_TASK_ID = null;
      this.parentsubTaskList = [];
      this.SUBTASK_PARENT_TASK_ID = null;
    }
  }

  moduleList: any = [];
  isFeatureModuleLoading: boolean = false;

  isTaskModuleLoading: boolean = false;
  isTaskFeatureLoading: boolean = false;
  isTaskCategoryLoading: boolean = false;
  isSubtaskModuleLoading: boolean = false;
  isSubtaskFeatureLoading: boolean = false;
  isSubtaskParentTaskLoading: boolean = false;
  isSubtaskCategoryLoading: boolean = false;
  subtaskFeatureList: any = [];

  loadAllModules() {
    sessionStorage.setItem("projectID", this.PROJECT_ID.toString());
    this.moduleList = [];
    this.isFeatureModuleLoading = true;
    this.isTaskModuleLoading = true;
    this.isSubtaskModuleLoading = true;

    this._apiService.getAllModules(0, 0, 'ID', 'asc', ' and IS_ACTIVE=1 and PROJECT_ID=' + this.PROJECT_ID).subscribe(moduleData => {
      if (moduleData['code'] == 200) {
        this.isFeatureModuleLoading = false;
        this.isTaskModuleLoading = false;
        this.isSubtaskModuleLoading = false;
        this.moduleList = moduleData['data'];
      } else {
        this.isFeatureModuleLoading = false;
        this.isTaskModuleLoading = false;
        this.isSubtaskModuleLoading = false;
        this.moduleList = [];
      }
    }, err => {
      this.isFeatureModuleLoading = false;
      this.isTaskModuleLoading = false;
      this.isSubtaskModuleLoading = false;
      this.moduleList = [];
    });
  }

  loadAllSubtaskFeatures(moduleID: any) {
    if (moduleID != null && moduleID != undefined && moduleID != '') {
      this.subtaskFeatureList = [];
      this.SUBTASK_FEATURE_ID = null;
      this.parentTaskList = [];
      this.PARENT_TASK_ID = null;
      this.parentsubTaskList = [];
      this.SUBTASK_PARENT_TASK_ID = null;
      this.isSubtaskFeatureLoading = true;
      this._apiService.getAllFeatures(0, 0, 'ID', 'asc', ' and IS_ACTIVE=1 and MODULE_ID=' + moduleID).subscribe(featureData => {
        if (featureData['code'] == 200) {
          this.isSubtaskFeatureLoading = false;
          this.subtaskFeatureList = featureData['data'];
        } else {
          this.isSubtaskFeatureLoading = false;
          this.subtaskFeatureList = [];
        }
      }, err => {
        this.isSubtaskFeatureLoading = false;
        this.subtaskFeatureList = [];
      });
    } else {
      this.subtaskFeatureList = [];
      this.SUBTASK_FEATURE_ID = null;
      this.parentTaskList = [];
      this.PARENT_TASK_ID = null;
      this.parentsubTaskList = [];
      this.SUBTASK_PARENT_TASK_ID = null;
    }

  }

  parentTaskList = [];
  parentsubTaskList = [];
  isSubtasksubTaskLoading: boolean = false;
  loadAllParentTasks(featureID) {
    if (featureID != null && featureID != undefined && featureID != '') {
      this.isSubtaskParentTaskLoading = true;
      this.parentTaskList = [];
      this.parentsubTaskList = [];
      this.SUBTASK_PARENT_TASK_ID = null;
      this.PARENT_TASK_ID = null;
      var taskassignid = '';
      taskassignid = " and ( TASK_ASSIGNEE_IDS ='" + this.loggedUserID + "' OR TASK_ASSIGNEE_IDS LIKE '%," + this.loggedUserID + "%' OR TASK_ASSIGNEE_IDS LIKE '%" + this.loggedUserID + ",%' OR TASK_ASSIGNEE_IDS LIKE '%," + this.loggedUserID + ",%')";

      this._apiService.getAllTaskSubtask(0, 0, 'ID', 'asc', ' and IS_ACTIVE=1 and PARENT_ID=0 and FEATURE_ID=' + featureID + taskassignid).subscribe(taskData => {
        if (taskData['code'] == 200) {
          this.isSubtaskParentTaskLoading = false;
          this.parentTaskList = taskData['data'];
        } else {
          this.isSubtaskParentTaskLoading = false;
          this.parentTaskList = [];
        }
      }, err => {
        this.isSubtaskParentTaskLoading = false;
        this.parentTaskList = [];
      });
    } else {
      this.parentTaskList = [];
      this.parentsubTaskList = [];
      this.SUBTASK_PARENT_TASK_ID = null;
      this.PARENT_TASK_ID = null;
    }
  }


  nodesData: any;
  fillTaskSubtaskWise(data: any) {
    if (data != null && data != undefined) {
      this.nodesData = this.parentTaskList.filter((item) => item.ID == Number(data));
      this.isSubtasksubTaskLoading = true;
      this.parentsubTaskList = [];
      this.SUBTASK_PARENT_TASK_ID = null;
      var subtaskassignid = ''
      subtaskassignid = " and ( SUBTASK_ASSIGNEE_IDS ='" + this.loggedUserID + "' OR SUBTASK_ASSIGNEE_IDS LIKE '%," + this.loggedUserID + "%' OR SUBTASK_ASSIGNEE_IDS LIKE '%" + this.loggedUserID + ",%' OR SUBTASK_ASSIGNEE_IDS LIKE '%," + this.loggedUserID + ",%')";
      this._apiService.getAllTaskSubtask(0, 0, 'ID', 'asc', ' and IS_ACTIVE=1 and PARENT_ID=' + data + ' and FEATURE_ID=' + this.SUBTASK_FEATURE_ID + subtaskassignid).subscribe(taskData => {
        if (taskData['code'] == 200) {
          this.isSubtasksubTaskLoading = false;
          this.parentsubTaskList = taskData['data'];
        } else {
          this.isSubtasksubTaskLoading = false;
          this.parentsubTaskList = [];
        }
      }, err => {
        this.isSubtasksubTaskLoading = false;
        this.parentsubTaskList = [];
      });
    } else {
      this.nodesData = null;
      this.isSubtasksubTaskLoading = false;
      this.parentsubTaskList = [];
      this.SUBTASK_PARENT_TASK_ID = null;
    }

  }

  spinSearch: boolean = false;
  searchworklog(pageIndex: number = 1, pageSize: number = 10) {
    this.isWorklogLoadMoreButtonHide = false;
    if (pageSize == 10) {
      this.isWorklogSpinning = true;
      this.worklogAddMorePage = 10;
    } else {
      this.isWorklogLoadMoreButtonSpinning = true;
    }
    var projectfilt = '';
    if (this.PROJECT_ID != null && this.PROJECT_ID != undefined && this.PROJECT_ID != '') {
      projectfilt = ' and PROJECT_ID=' + this.PROJECT_ID;
    } else {
      projectfilt = '';
    }
    var taskfilt = '';
    if (this.PARENT_TASK_ID != null && this.PARENT_TASK_ID != undefined && this.PARENT_TASK_ID != '') {
      taskfilt = ' and TYPE_ID=' + this.PARENT_TASK_ID;
    } else {
      taskfilt = '';
    }
    var datetime = '';
    if (this.WORKED_DATETIMEs != null && this.WORKED_DATETIMEs != undefined) {
      datetime = " and date(WORKED_DATETIME)='" + this.datePipe.transform(this.WORKED_DATETIMEs, 'yyyy-MM-dd') + "'";
    } else {
      datetime = '';
    }
    let filterStr = " and IS_ACTIVE=1 and USER_ID=" + this.loggedUserID + datetime;
    this.spinSearch = true;
    this.spinMain = true;
    this._apiService.getAllWorklogs(pageIndex, pageSize, 'WORKED_DATETIME', 'desc', filterStr).subscribe(data => {
      if (data['code'] == 200) {
        this.spinSearch = false;
        this.spinMain = false;
        this.isWorklogSpinning = false;
        this.isWorklogLoadMoreButtonSpinning = false;
        this.worklogData = data['data'];
        this.worklogcount = data['count'];
        this.totalhours = 0;
        this.totalminutes = 0;
        this.totalseconds = 0;

        if (data['count'] > 0) {
          this.totalhours = Math.floor(this.worklogData.reduce((sum, item) => sum + Number(item.SPENT_HOURS), 0));
          this.totalminutes = Math.floor(this.worklogData.reduce((sum, item) => sum + Number(item.SPENT_MINUTES), 0));
          this.totalseconds = Math.floor(this.worklogData.reduce((sum, item) => sum + Number(item.SPENT_SECONDS), 0));

          // Handle conversion of seconds and minutes
          if (this.totalseconds >= 60) {
            this.totalminutes += Math.floor(this.totalseconds / 60);
            this.totalseconds = this.totalseconds % 60;
          }
          if (this.totalminutes >= 60) {
            this.totalhours += Math.floor(this.totalminutes / 60);
            this.totalminutes = this.totalminutes % 60;
          }
        } else {
          this.totalhours = 0;
          this.totalminutes = 0;
          this.totalseconds = 0;
        }
        if (data['data'].length == data['count']) {
          this.isWorklogLoadMoreButtonHide = true;
        }
      } else {
        this.spinSearch = false;
        this.spinMain = false;
        this.worklogData = [];
        this.worklogcount = 0;
        this.totalhours = 0;
        this.totalminutes = 0;
        this.totalseconds = 0;
        this.isWorklogSpinning = false;
        this.isWorklogLoadMoreButtonSpinning = false;
      }

    }, err => {
      this.spinSearch = false;
      this.spinMain = false;
      this.isWorklogSpinning = false;
      this.isWorklogLoadMoreButtonSpinning = false;
      if (err['ok'] == false)
        this.notificationService.error("Server Not Found", "");
    });
  }

  dates = [];

  disabledEndDate = current => {
    let index = this.dates.findIndex(date => date === moment(current).format('YYYY-MM-DD'))
    return index === -1 && true
  }

  disabledDateTime: DisabledTimeFn = () => ({
    nzDisabledHours: () => [],
    nzDisabledMinutes: () => [],
    nzDisabledSeconds: () => []
  });

  startTimeInMilliseconds = 0;
  endTimeInMilliseconds = 0;
  tempStartDate: Date = null;

  sDateChange() {
    var startDate = new Date(this.worklogDrawerData.WORKED_DATETIME);
    startDate.setMilliseconds(0);
    startDate.setSeconds(0);
    this.startTimeInMilliseconds = startDate.getTime();
    if (this.startTimeInMilliseconds > 0) {
      this.dates = [];
      this.dates.push(this.datePipe.transform(this.worklogDrawerData.WORKED_DATETIME, "yyyy-MM-dd"));
      this.tempStartDate = new Date(this.worklogDrawerData.WORKED_DATETIME);
    } else {
      this.dates = [];
      this.tempStartDate = null;
    }
  }

  eDateChange() {
    var endDate = new Date(this.worklogDrawerData.END_DATETIME);
    endDate.setMilliseconds(0);
    endDate.setSeconds(0);
    this.endTimeInMilliseconds = endDate.getTime();
  }

  startDateChange() {
    this.sDateChange();
  }

  endDateChange() {
    this.sDateChange();
    this.eDateChange();
    this.getDifference(this.startTimeInMilliseconds, this.endTimeInMilliseconds)
  }

  getDifference(startTime, endTime) {
    var Difference_In_Time = endTime - startTime;
    if (Difference_In_Time > 0) {
      var seconds = Math.floor((Difference_In_Time / 1000) % 60);
      var minutes = Math.floor((Difference_In_Time / (1000 * 60)) % 60);
      var hours = Math.floor((Difference_In_Time / (1000 * 60 * 60)) % 24);
      var days = Math.floor(Difference_In_Time / (1000 * 60 * 60 * 24));

      if (hours < 10) { hours = 0 + hours; }
      if (minutes < 10) { minutes = 0 + minutes; }
      if (seconds < 10) { seconds = 0 + seconds; }

      this.worklogDrawerData.SPENT_HOURS = (days * 24) + hours;
      this.worklogDrawerData.SPENT_MINUTES = minutes;
      this.worklogDrawerData.SPENT_SECONDS = seconds;

    } else {
      this.worklogDrawerData.SPENT_HOURS = 0;
      this.worklogDrawerData.SPENT_MINUTES = 0;
      this.worklogDrawerData.SPENT_SECONDS = 0;
    }
  }


  @ViewChild('moduleEndDatePicker') moduleEndDatePicker: NzDatePickerComponent;

  moduleStartDateHandle(open: boolean) {
    if (!open) {
      this.moduleEndDatePicker.open();
    }
  }

  moduleEndDateHandle(open: boolean) {
    if (open) {
      if (this.tempStartDate != null) {
        this.worklogDrawerData.END_DATETIME = this.tempStartDate;
      }
      if (this.worklogDrawerData.END_DATETIME == null || this.worklogDrawerData.END_DATETIME == undefined) {
        this.worklogDrawerData.END_DATETIME = new Date();

      } else {
        this.worklogDrawerData.END_DATETIME = this.worklogDrawerData.END_DATETIME;
      }
    }
  }

  resetDrawer(worklogPage: NgForm) {
    worklogPage.form.reset();
    this.worklogDrawerData = new worklogM();
  }
  taskclick: any = '4';
  taskclicks(id: any) {
    this.taskclick = id;
  }
  isSpinning = false;

  save(addNew: boolean, worklogPage: NgForm): void {
    var isOk = true;
    if (!this.worklogDrawerData.ID && (this.PROJECT_ID == null || this.PROJECT_ID == undefined || this.PROJECT_ID == 0 || this.PROJECT_ID == '')) {
      isOk = false;
      this.notificationService.error("Please Select Project", "");
    } else if (!this.worklogDrawerData.ID && (this.SUBTASK_MODULE_ID == null || this.SUBTASK_MODULE_ID == undefined || this.SUBTASK_MODULE_ID == 0 || this.SUBTASK_MODULE_ID == '')) {
      isOk = false;
      this.notificationService.error("Please Select Module", "");
    } else if (!this.worklogDrawerData.ID && (this.SUBTASK_FEATURE_ID == null || this.SUBTASK_FEATURE_ID == undefined || this.SUBTASK_FEATURE_ID == 0 || this.SUBTASK_FEATURE_ID == '')) {
      isOk = false;
      this.notificationService.error("Please Select Feature", "");
    } else if (!this.worklogDrawerData.ID && (this.PARENT_TASK_ID == null || this.PARENT_TASK_ID == undefined || this.PARENT_TASK_ID == 0 || this.PARENT_TASK_ID == '')) {
      isOk = false;
      this.notificationService.error("Please Select Task", "");
    } else if (!this.worklogDrawerData.ID && (this.worklogDrawerData.WORKED_DATETIME == null || this.worklogDrawerData.WORKED_DATETIME == undefined || this.worklogDrawerData.WORKED_DATETIME == '' || this.worklogDrawerData.END_DATETIME == 0)) {
      isOk = false;
      this.notificationService.error("Please Select Start Datetime", "");
    } else if (!this.worklogDrawerData.ID && (this.worklogDrawerData.END_DATETIME == null || this.worklogDrawerData.END_DATETIME == undefined || this.worklogDrawerData.END_DATETIME == 0 || this.worklogDrawerData.END_DATETIME == '')) {
      isOk = false;
      this.notificationService.error("Please Select End Datetime", "");
    } else if (!this.worklogDrawerData.ID && (this.worklogDrawerData.SPENT_HOURS == 0 && this.worklogDrawerData.SPENT_MINUTES == 0 && this.worklogDrawerData.SPENT_SECONDS == 0)) {
      isOk = false;
      this.notificationService.error("Please Enter Valid Spent Time", "");
    } else if (!this.worklogDrawerData.ID && (this.worklogDrawerData.WORK_DESCRIPTION == null || this.worklogDrawerData.WORK_DESCRIPTION == undefined || this.worklogDrawerData.WORK_DESCRIPTION == '')) {
      isOk = false;
      this.notificationService.error("Please Enter Valid Work Description", "");
    }

    if (isOk) {
      this.isSpinning = true;
      this.worklogDrawerData.USER_ID = this._apiService.userId;
      if (!this.worklogDrawerData.ID) {
        if (this.PARENT_TASK_ID != null && this.PARENT_TASK_ID != undefined && this.SUBTASK_PARENT_TASK_ID != null && this.SUBTASK_PARENT_TASK_ID != undefined) {
          this.worklogDrawerData.TYPE = 5;
        } else {
          this.worklogDrawerData.TYPE = 4;
        }
        this.worklogDrawerData.TYPE_ID = this.nodesData[0]['ID'];
        this.worklogDrawerData.IS_ACTIVE = true;
        this.worklogDrawerData.WORKED_DATETIME = this.datePipe.transform(this.worklogDrawerData.WORKED_DATETIME, "yyyy-MM-dd HH:mm") + ":00";
        this.worklogDrawerData.START_DATETIME = this.datePipe.transform(this.worklogDrawerData.WORKED_DATETIME, "yyyy-MM-dd HH:mm") + ":00";
        this.worklogDrawerData.END_DATETIME = this.datePipe.transform(this.worklogDrawerData.END_DATETIME, "yyyy-MM-dd HH:mm") + ":00";
        this.worklogDrawerData.PROJECT_ID = sessionStorage.getItem('projectID');
        this._apiService.createWorklog(this.worklogDrawerData).subscribe(successCode => {
          if (successCode['code'] == "200") {
            this.notificationService.success("Work Log Added Successfully", "");
            this.isSpinning = false;
            this.showtrue = false;

            if (!addNew) {
              this.resetDrawer(worklogPage);
              this.worklogDrawerData = new worklogM();

              this.getWorklogIDWise(1, 5);
              this.logtext = 'Save & Close - Worklog Master form - SUCCESS - ' + JSON.stringify(this.worklogDrawerData) + " KEYWORD [C - Worklog Master ]";
              this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
                if (successCode['code'] == "200") {
                }
                else {
                }
              });

            } else {
              this.resetDrawer(worklogPage);
              this.getWorklogIDWise(1, 5);
              this.worklogDrawerData = new worklogM();

              this.logtext = 'Save & New - Worklog Master form - SUCCESS - ' + JSON.stringify(this.worklogDrawerData) + " KEYWORD [C - Worklog Master ]";
              this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
                if (successCode['code'] == "200") {
                }
                else {
                }
              });
            }
            this.PROJECT_ID = null;
            this.moduleList = [];
            this.SUBTASK_MODULE_ID = null;
            this.subtaskFeatureList = [];
            this.SUBTASK_FEATURE_ID = null;
            this.parentTaskList = [];
            this.PARENT_TASK_ID = null;
            this.parentsubTaskList = [];
            this.SUBTASK_PARENT_TASK_ID = null;
          } else {
            this.isSpinning = false;
            this.notificationService.error("Failed to Add Work Log", "");
            this.logtext = 'Save & Close - Worklog Master form - ERROR - ' + JSON.stringify(this.worklogDrawerData) + " KEYWORD [C - Worklog Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {
              }
              else {
              }
            });
          }

        }, err => {
          this.isSpinning = false;
          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        });

      } else {
        this.worklogDrawerData.IS_ACTIVE = true;
        this.worklogDrawerData.WORKED_DATETIME = this.datePipe.transform(this.worklogDrawerData.WORKED_DATETIME, "yyyy-MM-dd HH:mm") + ":00";
        this.worklogDrawerData.START_DATETIME = this.datePipe.transform(this.worklogDrawerData.WORKED_DATETIME, "yyyy-MM-dd HH:mm") + ":00";
        this.worklogDrawerData.END_DATETIME = this.datePipe.transform(this.worklogDrawerData.END_DATETIME, "yyyy-MM-dd HH:mm") + ":00";
        this._apiService.updateWorklog(this.worklogDrawerData).subscribe(successCode => {
          if (successCode['code'] == "200") {
            this.showtrue = false;
            this.resetDrawer(worklogPage);
            this.worklogDrawerData = new worklogM();
            this.isSpinning = false;
            this.getWorklogIDWise(1, 5);
            this.notificationService.success("Work Log Updated Successfully", "");
            this.logtext = 'Update & Close - Worklog Master form - SUCCESS - ' + JSON.stringify(this.worklogDrawerData) + " KEYWORD [C - Worklog Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {
              }
              else {
              }
            });

            this.isSpinning = false;
            this.PROJECT_ID = null;
            this.moduleList = [];
            this.SUBTASK_MODULE_ID = null;
            this.subtaskFeatureList = [];
            this.SUBTASK_FEATURE_ID = null;
            this.parentTaskList = [];
            this.PARENT_TASK_ID = null;
            this.parentsubTaskList = [];
            this.SUBTASK_PARENT_TASK_ID = null;
          } else {
            this.isSpinning = false;

            this.notificationService.error("Failed to Update Work Log", "");
            this.logtext = 'Update & Close - Worklog Master form - ERROR - ' + JSON.stringify(this.worklogDrawerData) + " KEYWORD [C - Worklog Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {
              }
              else {
              }
            });
          }

        }, err => {
          this.isSpinning = false;
          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        });
      }
    }
  }

  modalForSubtask: boolean = false;
  roleData: any = [];

  addSubTask() {
    var isOk = true;
    if ((this.PROJECT_ID == null || this.PROJECT_ID == undefined || this.PROJECT_ID == 0 || this.PROJECT_ID == '')) {
      isOk = false;
      this.notificationService.error("Please Select Project", "");
    } else if ((this.SUBTASK_MODULE_ID == null || this.SUBTASK_MODULE_ID == undefined || this.SUBTASK_MODULE_ID == 0 || this.SUBTASK_MODULE_ID == '')) {
      isOk = false;
      this.notificationService.error("Please Select Module", "");
    } else if ((this.SUBTASK_FEATURE_ID == null || this.SUBTASK_FEATURE_ID == undefined || this.SUBTASK_FEATURE_ID == 0 || this.SUBTASK_FEATURE_ID == '')) {
      isOk = false;
      this.notificationService.error("Please Select Feature", "");
    } else if ((this.PARENT_TASK_ID == null || this.PARENT_TASK_ID == undefined || this.PARENT_TASK_ID == 0 || this.PARENT_TASK_ID == '')) {
      isOk = false;
      this.notificationService.error("Please Select Task", "");
    }
    if (isOk) {
      this.modalForSubtask = true;
      this.loadAllCategories();
      this.loadAllAssignee();
      this.loadAllRoles();
    }
  }

  cancelSubTask() {
    this.modalForSubtask = false;
  }
  loadAllAssignee() {
    this.assigneeList = [];
    var USER_ID = this._apiService.userId;
    this._apiService.getAllMappedUsers(0, 0, 'LEVEL', 'asc', ' and IS_ACTIVE=1 and PROJECT_ID=' + this.PROJECT_ID).subscribe(userData => {
      if (userData['code'] == 200) {
        this.assigneeList = userData['data'];
        this.findNewAssigneeList();
      }

    }, err => {

    });
  }

  categoryList: any = [];
  SUBTASK_CATEGORY_ID: any = 0;

  loadAllCategories() {
    this.categoryList = [];

    this._apiService.getAllCategories(0, 0, 'ID', 'asc', ' and IS_ACTIVE=1').subscribe(categoryData => {
      if (categoryData['code'] == 200) {
        this.isTaskCategoryLoading = false;
        this.isSubtaskCategoryLoading = false;
        this.categoryList = categoryData['data'];

        this.TASK_CATEGORY_ID = 0;
        this.SUBTASK_CATEGORY_ID = 0;
        var USER_ID = this._apiService.userId;

        this._apiService.getAllUsers(0, 0, 'ID', 'desc', ' and ID=' + USER_ID).subscribe(userData => {
          this.TASK_CATEGORY_ID = userData['data'][0]['TASK_CATEGORY_ID'];
          this.SUBTASK_CATEGORY_ID = userData['data'][0]['TASK_CATEGORY_ID'];

        }, err => {
        });
      }

    }, err => {
    });
  }
  loadAllRoles() {
    this.roleData = [];
    var level = this.cookie.get("level");
    var nextLevel = Number(this.cookie.get("level")) + 1;

    level = level + ',' + nextLevel;

    if (this.cookie.get("level") == "1" || this.cookie.get("level") == "2") {
      this._apiService.getAllRoles(0, 0, 'ID', 'desc', '').subscribe(data => {
        if (data['code'] == 200) {
          this.roleData = data['data'];

          this.findNewAssigneeList();
        }

      }, err => {

      });

    } else {
      this._apiService.getAllRoles(0, 0, 'ID', 'asc', '').subscribe(data => {
        if (data['code'] == 200) {
          this.roleData = data['data'];
          this.findNewAssigneeList();
        }
      }, err => { });
    }
  }

  newAssigneeList: any = [];
  newAssigneeList1: any = [];
  SUBTASK_ASSIGNEE_ID: any = [];
  TASK_CATEGORY_ID: any = 0;
  assigneeList: any = [];
  SUBTASK_NAME: any;
  SUBTASK_PRIORITY = "L";
  SUBTASK_START_DATE: Date = null;
  SUBTASK_END_DATE: Date = null;
  SUBTASK_DESCRIPTION: any
  AllAssignee: boolean = false;
  SUBTASK_ESTIMATED_HOURS = 0;
  SUBTASK_ESTIMATED_MINUTES = 0;
  SUBTASK_ESTIMATED_SECONDS = 0;
  selectAllAssignee() {
    this.findNewAssigneeList();
  }
  findNewAssigneeList() {
    this.newAssigneeList = [];
    this.newAssigneeList1 = [];
    for (var j = 0; j < this.roleData.length; j++) {
      for (var k = 0; k < this.assigneeList.length; k++) {
        if (this.assigneeList[k]['ROLE_ID'] == this.roleData[j]['ID']) {
          this.newAssigneeList.push(this.assigneeList[k]);
          this.newAssigneeList1.push(this.assigneeList[k]);
        }
      }
    }

    // Pre select of Level 3 Users
    this.SUBTASK_ASSIGNEE_ID = [];

    var currentCat = 0;

    if (this.AllAssignee) {
      for (var i = 0; i < this.newAssigneeList1.length; i++) {
        this.SUBTASK_ASSIGNEE_ID.push(this.newAssigneeList1[i]['USER_ID']);
        currentCat = this.newAssigneeList1[i]['TASK_CATEGORY_ID'];
        this.TASK_CATEGORY_ID = currentCat;
      }
    } else {
      for (var i = 0; i < this.newAssigneeList.length; i++) {
        if (this.newAssigneeList[i]['LEVEL'] == 3) {
          this.SUBTASK_ASSIGNEE_ID.push(this.newAssigneeList[i]['USER_ID']);
        }

        if (this.newAssigneeList[i]['LEVEL'] == 4) {
          if (this.newAssigneeList[i]['USER_ID'] == Number(this.cookie.get("userId"))) {
            this.SUBTASK_ASSIGNEE_ID.push(this.newAssigneeList[i]['USER_ID']);
            currentCat = this.newAssigneeList[i]['TASK_CATEGORY_ID'];
            this.TASK_CATEGORY_ID = currentCat;
          }
        }

        if (this.newAssigneeList[i]['LEVEL'] == 5) {
          if (this.newAssigneeList[i]['TASK_CATEGORY_ID'] == currentCat) {
            this.SUBTASK_ASSIGNEE_ID.push(this.newAssigneeList[i]['USER_ID']);
          }
        }
      }
    }

  }
  disabledSubtaskEndDate = (endValue: Date): boolean => {
    if (this.SUBTASK_START_DATE != null) {
      if (!endValue) {
        return false;
      }

      var subtaskPreviousDate = new Date(this.SUBTASK_START_DATE);
      subtaskPreviousDate.setDate(subtaskPreviousDate.getDate() + (-1));

      return endValue <= new Date(subtaskPreviousDate);
    };
  }

  @ViewChild('subtaskEndDatePicker') subtaskEndDatePicker: NzDatePickerComponent;

  subtaskStartDateHandle(open: boolean) {
    this.SUBTASK_END_DATE = null;

    if (!open) {
      this.subtaskEndDatePicker.open();
      this.SUBTASK_END_DATE = this.SUBTASK_START_DATE;
    }
  }

  taskDrawerData = new taskSubtaskMaster;
  mappingData: any = [];
  loadingsubtask: boolean = false;
  handleOk(reset: boolean = false): void {
    var isOK = true;
    if (this.SUBTASK_NAME == undefined || this.SUBTASK_NAME == null || this.SUBTASK_NAME.trim() == "") {
      isOK = false;
      this.notificationService.error("Please Enter Valid Sub Task  Name", "");
    } else if (this.SUBTASK_ASSIGNEE_ID == undefined || this.SUBTASK_ASSIGNEE_ID == null || this.SUBTASK_ASSIGNEE_ID.length == 0) {
      isOK = false;
      this.notificationService.error("Please Select Valid Assignee", "");
    } else if (this.SUBTASK_CATEGORY_ID == undefined || this.SUBTASK_CATEGORY_ID == null || this.SUBTASK_CATEGORY_ID.length == 0) {
      isOK = false;
      this.notificationService.error("Please Select Valid Sub Task  Category", "");
    } else if (this.SUBTASK_PRIORITY == undefined || this.SUBTASK_PRIORITY == null || this.SUBTASK_PRIORITY == "") {
      isOK = false;
      this.notificationService.error("Please Select Valid Sub Task  Priority", "");
    }
    if (isOK) {
      this.taskDrawerData.TASK_CATEGORY_ID = this.SUBTASK_CATEGORY_ID;
      this.taskDrawerData.FEATURE_ID = this.SUBTASK_FEATURE_ID;
      this.taskDrawerData.PARENT_ID = this.PARENT_TASK_ID;
      this.taskDrawerData.NAME = this.SUBTASK_NAME;
      this.taskDrawerData.DESCRIPTION = this.SUBTASK_DESCRIPTION;
      this.taskDrawerData.ESTIMATED_HOURS = this.SUBTASK_ESTIMATED_HOURS ? this.SUBTASK_ESTIMATED_HOURS : 0;
      this.taskDrawerData.ESTIMATED_MINUTES = this.SUBTASK_ESTIMATED_MINUTES ? this.SUBTASK_ESTIMATED_MINUTES : 0;
      this.taskDrawerData.ESTIMATED_SECONDS = this.SUBTASK_ESTIMATED_SECONDS ? this.SUBTASK_ESTIMATED_SECONDS : 0;

      this.taskDrawerData.PRIORITY = this.SUBTASK_PRIORITY;

      this.taskDrawerData.TIME_TRACKED = new Date();
      this.taskDrawerData.TIME_TRACKED = this.datePipe.transform(this.taskDrawerData.TIME_TRACKED, "HH:mm") + ":00";

      this.taskDrawerData.STATUS = "P";

      this.taskDrawerData.START_DATE = this.datePipe.transform(this.SUBTASK_START_DATE, "yyyy-MM-dd");
      this.taskDrawerData.END_DATE = this.datePipe.transform(this.SUBTASK_END_DATE, "yyyy-MM-dd");

      this.taskDrawerData.IS_CHILD = false;
      this.taskDrawerData.DEPENDENT_TASK_ID = 0;

      this.taskDrawerData.UPDATED_DATETIME = new Date();
      this.taskDrawerData.UPDATED_DATETIME = this.datePipe.transform(this.taskDrawerData.UPDATED_DATETIME, "yyyy-MM-dd HH:mm") + ":00";

      this.taskDrawerData.TAGS = "";
      this.taskDrawerData.PROGRESS = 0;
      this.taskDrawerData.IS_ACTIVE = true;
      this.taskDrawerData.ASSIGNEES = this.SUBTASK_ASSIGNEE_ID;
      this.taskDrawerData.REPORTER_ID = this._apiService.userId;
      this.taskDrawerData.TYPE = 5;
      this.loadingsubtask = true;
      this._apiService.createTaskSubtask(this.taskDrawerData).subscribe(successCode => {
        if (successCode['code'] == "200") {
          this.notificationService.success("Sub Task Created Successfully", "");
          var createdTaskID = successCode['ID'];

          this._apiService.getTaskSubtaskDetails(createdTaskID, 0).subscribe(data => {
            if (data['code'] == "200") {
              this.mappingData = data['data'];
              for (var i = 0; i < this.mappingData.length; i++) {
                for (var j = 0; j < this.SUBTASK_ASSIGNEE_ID.length; j++) {
                  if (this.mappingData[i]['USER_ID'] == this.SUBTASK_ASSIGNEE_ID[j]) {
                    this.mappingData[i]['IS_ACTIVE'] = 1;
                    this.mappingData[i]['ROLE_ID'] = Number(this.mappingData[i]['ROLE_IDS']);
                  }
                }
              }
              this._apiService.addTaskSubtaskMappingDetails(createdTaskID, this.mappingData).subscribe(successCode => {
                if (successCode['code'] == "200") {
                  this.loadingsubtask = false;
                  this.notificationService.success("Sub Task Mapped Successfully", "");
                  if (!reset) {
                    this.modalClear();
                    this.handleCancel();
                  } else {
                    this.clearValue();
                  }
                }
                else {
                  this.loadingsubtask = false;
                  this.notificationService.error("Sub Task Mapping Failed", "");
                }
              }, err => {
                this.loadingsubtask = false;
              });
            } else {
              this.loadingsubtask = false;
            }
          }, err => {
            this.loadingsubtask = false;
          });

        } else {
          this.loadingsubtask = false;
          this.notificationService.error("Failed to Create Sub Task ", "");
        }
      }, err => {
        this.loadingsubtask = false;
        if (err["ok"] == false) {
          this.notificationService.error("Server Not Found", "");
        }
      });
    }
  }

  handleCancel(): void {
    this.modalForSubtask = false;
    this.loadingsubtask = false;
    this.fillTaskSubtaskWise(this.PARENT_TASK_ID);
    this.modalClear();
  }
  clearValue() {
    this.SUBTASK_NAME = "";
    this.SUBTASK_DESCRIPTION = "";
  }
  modalClear() {
    this.TASK_CATEGORY_ID = 0;
    this.SUBTASK_NAME = "";
    this.SUBTASK_DESCRIPTION = "";
    this.SUBTASK_ASSIGNEE_ID = [];
    this.SUBTASK_START_DATE = null;
    this.SUBTASK_END_DATE = null;
    this.SUBTASK_PRIORITY = "L";
    this.SUBTASK_ESTIMATED_HOURS = 0;
    this.SUBTASK_ESTIMATED_MINUTES = 0;
    this.SUBTASK_ESTIMATED_SECONDS = 0;
  }
}